export function getTranslateKeyForContactField(ContactField: string) {
  switch (ContactField) {
    case 'firstName':
      return 'CONTACT_DETAIL.FIRST_NAME';
    case 'lastName':
      return 'CONTACT_DETAIL.LAST_NAME';
    case 'email':
      return 'CONTACT_DETAIL.EMAIL';
    case 'company':
      return 'CONTACT_DETAIL.COMPANY';
    case 'externalLink':
      return 'CONTACT_DETAIL.EXTERNAL_LINK';
    case 'tags':
      return 'CONTACT_DETAIL.TAGS';
    default:
      return '';
  }
}
